import { type ReactNode } from 'react';
import { cn } from '../../lib/cn';

// Заголовок группы внутри списка: «Нужен ваш ответ · 2». Липнет к верху при прокрутке,
// поэтому в длинном списке всегда видно, в какой ты группе.
//
// Тон urgent - для групп, где ждут человека: розовая подложка выделяет её из потока,
// но не кричит, как сплошная заливка.

export function ListGroupHeader({
  title,
  count,
  tone,
  action,
  className,
}: {
  title: string;
  count?: number;
  tone?: 'urgent';
  /** Необязательная ссылка справа: «вся история», «настроить» и т.п. */
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'sticky top-0 z-2 flex items-center gap-2 border-b border-line px-4 py-2 text-[11px] font-bold uppercase tracking-wide',
        tone === 'urgent' ? 'bg-destructive/10 text-destructive' : 'bg-bg text-muted',
        className,
      )}
    >
      {title}
      {action ? <span className="ml-auto font-semibold normal-case tracking-normal">{action}</span> : null}
      {count !== undefined ? (
        <span className={cn('tabular-nums', action ? '' : 'ml-auto')}>{count}</span>
      ) : null}
    </div>
  );
}
